<div class="dialog-page">
  <div class="header">
    <button mat-icon-button type="button" (click)="cerrar()">
      <mat-icon>arrow_back</mat-icon>
    </button>

    <div>
      <h1>Historial de signos vitales</h1>
      <p>
        {{ data.paciente.nombre }} {{ data.paciente.apellido }} {{ data.paciente.segundoApellido }}
      </p>
    </div>
  </div>

  @if (data.signosVitales.length === 0) {
    <p class="sin-datos">Este paciente no tiene signos vitales registrados.</p>
  } @else {
    <div class="tabla-scroll">
      <table mat-table [dataSource]="data.signosVitales" class="tabla-signos">
        <ng-container matColumnDef="fecha">
          <th mat-header-cell *matHeaderCellDef>Fecha</th>
          <td mat-cell *matCellDef="let sv">{{ sv.fechaRegistro | date: 'dd/MM/yyyy HH:mm' }}</td>
        </ng-container>

        <ng-container matColumnDef="peso">
          <th mat-header-cell *matHeaderCellDef>Peso</th>
          <td mat-cell *matCellDef="let sv">{{ dato(sv.peso, ' kg') }}</td>
        </ng-container>

        <ng-container matColumnDef="talla">
          <th mat-header-cell *matHeaderCellDef>Talla</th>
          <td mat-cell *matCellDef="let sv">{{ dato(sv.estatura, ' m') }}</td>
        </ng-container>

        <!-- Frecuencia cardiaca -->
        <ng-container matColumnDef="fc">
          <th mat-header-cell *matHeaderCellDef>FC</th>
          <td mat-cell *matCellDef="let sv">
            {{ dato(sv.frecuenciaCardiaca, ' lpm') }}
          </td>
        </ng-container>

        <!-- Frecuencia respiratoria -->
        <ng-container matColumnDef="fr">
          <th mat-header-cell *matHeaderCellDef>FR</th>
          <td mat-cell *matCellDef="let sv">
            {{ dato(sv.frecuenciaRespiratoria, ' rpm') }}
          </td>
        </ng-container>

        <!-- Saturación de oxígeno -->
        <ng-container matColumnDef="sato2">
          <th mat-header-cell *matHeaderCellDef>SpO₂</th>
          <td mat-cell *matCellDef="let sv">
            {{ dato(sv.saturacionOxigeno, ' %') }}
          </td>
        </ng-container>

        <ng-container matColumnDef="temperatura">
          <th mat-header-cell *matHeaderCellDef>Temp.</th>
          <td mat-cell *matCellDef="let sv">{{ dato(sv.temperatura, ' °C') }}</td>
        </ng-container>

        <ng-container matColumnDef="ta">
          <th mat-header-cell *matHeaderCellDef>TA</th>
          <td mat-cell *matCellDef="let sv">{{ presion(sv) }}</td>
        </ng-container>

        <ng-container matColumnDef="observaciones">
          <th mat-header-cell *matHeaderCellDef>Observaciones</th>
          <td mat-cell *matCellDef="let sv">{{ observacion(sv) }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="columnas; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: columnas"></tr>
      </table>
    </div>
  }
</div>
